import { PureComponent } from 'react'
import { PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import styles from './index.css'
import LimitationContainer from './Limitation/LimitationContainer'
import MoreInfo from './MoreInfo'
import { ProposalBlock } from '@vzmi/shp_shared_compo'

export class ProductDetail extends PureComponent {
  render () {
    const { className, user, flags, fromClone, proposalType, change } = this.props
    const isNewProposal = !fromClone
    const isListingProposal = (proposalType === PROPOSAL_TYPE.NEW_LISTING)
    return (
      <div
        data-role='compose-product-detail'
        className={`${styles.ProductDetail} ${className}`}
      >
        <ProposalBlock>
          <LimitationContainer
            triggerFieldChange={change}
            user={user}
            flags={flags}
            isNewProposal={isNewProposal}
          />
          <MoreInfo
            flags={flags}
            user={user}
            isNewProposal={isNewProposal}
            isListingProposal={isListingProposal}
            change={change}
          />
        </ProposalBlock>
      </div>
    )
  }
}

export default ProductDetail
